var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"app-version-tag is-padded-small",class:[{ 'badge-tag': _vm.badge }]},[_vm._v("\n    App Version "+_vm._s(_vm.appVersion)+"\n  ")]),(_vm.isDevelopment)?_c('span',{staticClass:"dev-badge"},[_vm._v("Development")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }